import { useEffect } from 'react';
const EVENT_NAME = 'click';
const useClickOutside = (action, ref, condition = true) => {
  useEffect(() => {
    const handleClick = event => {
      if (ref.current && !ref.current.contains(event.target) && condition) {
        action();
      }
    };
    window?.addEventListener(EVENT_NAME, handleClick);
    return () => window.removeEventListener(EVENT_NAME, handleClick);
  });
};
export { useClickOutside };
//# sourceMappingURL=useClickOutside.js.map
